'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002478 from "./presto.-Two-Factor-Auth-View$$anon$78.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002480 from "./presto.-Two-Factor-Auth-View$$anon$80.js";
import * as $j_presto$002etypes$0024$002dSelected$002dSite$0024 from "./presto.types$-Selected-Site$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$77() {
  this.bGS = null;
  this.bGK = null;
  this.bGL = false;
  this.bGT = null;
  this.bGU = false;
  this.bGX = null;
  this.bGQ = null;
  this.bGR = false;
  this.bGM = null;
  this.bGN = false;
  this.bGO = null;
  this.bGP = false;
  this.bGV = false;
  this.bGW = false;
  this.bGS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bGX = "SelectedSite";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$77 as $c_Lpresto_TwoFactorAuthView$$anon$77 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$77.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$77;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$77() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$77 as $h_Lpresto_TwoFactorAuthView$$anon$77 };
$h_Lpresto_TwoFactorAuthView$$anon$77.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bGS;
});
$p.M = (function() {
  if ((!this.bGL)) {
    this.bGK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bGL = true;
  }
  return this.bGK;
});
$p.O = (function() {
  if ((!this.bGU)) {
    this.bGT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bGU = true;
  }
  return this.bGT;
});
$p.E = (function() {
  return this.bGX;
});
$p.t = (function() {
  if ((!this.bGR)) {
    this.bGQ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("site", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("selected", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bGR = true;
  }
  return this.bGQ;
});
$p.N = (function() {
  if ((!this.bGN)) {
    this.bGM = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002478.$c_Lpresto_TwoFactorAuthView$$anon$78(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().at, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bGN = true;
  }
  return this.bGM;
});
$p.Q = (function() {
  if ((!this.bGP)) {
    this.bGO = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002480.$c_Lpresto_TwoFactorAuthView$$anon$80();
    this.bGP = true;
  }
  return this.bGO;
});
$p.v = (function() {
  if ((!this.bGW)) {
    this.bGV = false;
    this.bGW = true;
  }
  return this.bGV;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee864) => ((p) => \u03b4scrutinee864.acY(p)))($j_presto$002etypes$0024$002dSelected$002dSite$0024.$m_Lpresto_types$SelectedSite$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$77 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$77, "presto.TwoFactorAuthView$$anon$77", ({
  TD: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$77 as $d_Lpresto_TwoFactorAuthView$$anon$77 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$77.js.map
